import React from "react";
import { Col, Row, Card, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const MonthlyPlanPageSummary = (props) => {
  return (
    <Row id="summaryArea" style={{ ...props.style }}>
      <Col span={24}>
        <Card
          hoverable
          style={{
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
            background: "linear-gradient(to right, #e3f2fd, #ffffff)",
          }}
          bodyStyle={{ padding: 0 }}
        >
          {props.loading ? (
            <Row justify="center" align="middle" style={{ height: "130px" }}>
              <Spin style={{ margin: 5 }} />
            </Row>
          ) : (
            <Row justify="center">
              <Col
                xs={24}
                style={{
                  textAlign: "right",
                  color: "#777",
                  paddingTop: 8,
                  paddingRight: 40,
                  marginBottom: -5,
                  fontSize: 12,
                }}
              >
                <p>{props.info}</p>
              </Col>

              {props.data.map((item, index) => (
                <Col
                  key={index}
                  xs={24}
                  md={12}
                  lg={6}
                  style={{ textAlign: "center", marginBottom: 20 }}
                >
                  {/* Başlık */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "15px",
                      color: "#777",
                    }}
                  >
                    <p>
                      <InfoCircleOutlined
                        style={{
                          color: "blue",
                          fontSize: "150%",
                          backgroundColor: "#d6ebf9",
                          borderRadius: "50%",
                          padding: "8px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                      />
                    </p>
                    <h4 style={{ fontWeight: "600", color: "#333" }}>
                      {item.processType === 1
                        ? "Tahsilat"
                        : item.processType === 2
                        ? "Ödeme"
                        : ""}{" "}
                      Toplam
                    </h4>
                  </div>

                  <hr
                    style={{
                      width: "60%",
                      margin: "auto",
                      marginBottom: 10,
                    }}
                  />

                  {/* Özet bilgileri */}
                  {item.amountSummary.map((summary, sIndex) => (
                    <div key={sIndex} style={{ marginBottom: "15px" }}>
                      {/* Genel toplam */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                          color: "#555",
                        }}
                      >
                        <p>
                          Adet:{" "}
                          <span style={{ fontWeight: "500" }}>
                            {summary.total}
                          </span>
                        </p>
                        <p>
                          Tutar:{" "}
                          <span style={{ fontWeight: "500" }}>
                            {summary.amount}
                          </span>
                        </p>
                      </div>

                      {/* Tamamlanan */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                          color: "green",
                        }}
                      >
                        <p>
                          Tamamlanan Adet:{" "}
                          <span style={{ fontWeight: "500" }}>
                            {summary.completedTotal}
                          </span>
                        </p>
                        <p>
                          Tutar:{" "}
                          <span style={{ fontWeight: "500" }}>
                            {summary.completedAmount}
                          </span>
                        </p>
                      </div>

                      {/* Açık */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "15px",
                          color: "red",
                        }}
                      >
                        <p>
                          Açık Adet:{" "}
                          <span style={{ fontWeight: "500" }}>
                            {summary.openTotal}
                          </span>
                        </p>
                        <p>
                          Tutar:{" "}
                          <span style={{ fontWeight: "500" }}>
                            {summary.openAmount}
                          </span>
                        </p>
                      </div>
                    </div>
                  ))}
                </Col>
              ))}
            </Row>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default MonthlyPlanPageSummary;
